import { render } from "./ViewsAuthLoginSso.vue?vue&type=template&id=944f5d98"
import script from "./ViewsAuthLoginSso.vue?vue&type=script&lang=js"
export * from "./ViewsAuthLoginSso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__